import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import ChatLocationProvider, { MapLatLongType } from "./ChatLocationProvider";
import { sendChatMessage } from "../../../../libraries/state_reducers/chats/ChatsReducer";
import { removeModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";

type ChatLocationContextType = {
  coordinates: MapLatLongType | null;
  currentLocationAccuracy: number;
  handleClickLocation: (lat: number, lng: number, title: string) => void;

  // SEARCH
  searchValue: string;
  showSearch: boolean;
  handleOnChange: (name: string, value: string) => void;
  clearSearch: () => void;
  updateShowSearch: () => void;
};

const ChatLocationContext = createContext<ChatLocationContextType | undefined>(
  undefined
);

export const ChatLocationContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const type: number = ResponsiveDeviceType();

  const dispatch = useDispatch();

  const searchValueRef = useRef<string>("");
  const coordinatesRef = useRef<MapLatLongType | null>(null);

  const [coordinates, setCoordinates] = useState<MapLatLongType | null>(null);
  const [currentLocationAccuracy, setCurrentLocationAccuracy] =
    useState<number>(0);

  const [searchValue, setSearchValue] = useState<string>("");
  const [showSearch, setShowSearch] = useState<boolean>(false);

  const getGoogleCurrentLocation = async () => {
    console.log("getGoogleCurrentLocation");
    //setCoordinates(null);

    const coordinates: MapLatLongType | null =
      await ChatLocationProvider.getGoogleCurrentLocation();

    if (coordinates != null) {
      setCoordinates(coordinates);
      coordinatesRef.current = coordinates;
      setCurrentLocationAccuracy(coordinates.accuracy);

      setShowSearch(type === 3 ? true : false);
    }
  };

  const handleClickLocation = (
    lat: number = 0,
    lng: number = 0,
    title: string = ""
  ) => {
    const msg: string = `${title}|${lat}|${lng}`;
    dispatch(sendChatMessage({ messageType: "5", message: msg }));
    dispatch(removeModal(ModalKeys.chat_location));
    window.history.replaceState(null, "", window.location.pathname);
  };

  const handleOnChange = (fieldName: string, fieldValue: string) => {
    fieldName = fieldName.toLowerCase();
    if (fieldName === `search-map-location`) {
      setSearchValue(fieldValue);
    }
  };

  const clearSearch = () => {
    if (UtilityHelper.isEmpty(searchValueRef.current)) {
      updateShowSearch();
    }
    setSearchValue("");
    searchValueRef.current = "";
  };

  const updateShowSearch = () => {
    setShowSearch(type === 3 ? true : !showSearch);
  };

  useEffect(() => {
    getGoogleCurrentLocation();
    // eslint-disable-next-line
  }, []);

  return (
    <ChatLocationContext.Provider
      value={{
        coordinates,
        currentLocationAccuracy,
        handleClickLocation,

        //SEARCH
        searchValue,
        showSearch,
        handleOnChange,
        updateShowSearch,
        clearSearch,
      }}
    >
      {children}
    </ChatLocationContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const ChatLocationContextImport = () => {
  const context = useContext(ChatLocationContext);
  if (!context) {
    throw new Error(
      "ChatLocationContextImport must be used within a ChatLocationContextProvider"
    );
  }
  return context;
};
